import { RobotTypeEnum } from '@/generated/model/robotTypeEnum'

export const hasRightPalletModeOption = (robotType: RobotTypeEnum): boolean => {
  return [RobotTypeEnum.GENERIC, RobotTypeEnum.RC12, RobotTypeEnum.RC20].includes(robotType)
}
